import http from '../../core/services/http'

export const generateUserCountsReport = ({ userId }) =>
  http.get(`/reports/user-counts?userId=${userId}`, { responseType: 'blob' })
